import { HTMLAttributes, PropsWithChildren } from "react";

import Callout from "@components/callout/callout";
import { classNames } from "@helpers/css";

const AssessmentLayout = ({ children }: PropsWithChildren) => (
  <div className={classNames()}>{children}</div>
);

const AssessmentTypeSection = ({ children }: PropsWithChildren) => (
  <div className="border-b last:border-0 pb-12 mb-12">
    <div className="w-full mx-auto max-w-(--breakpoint-lg)">{children}</div>
  </div>
);
const AssessmentTypeHeader = ({
  children,
  id,
}: PropsWithChildren & { id?: string }) => (
  <div id={id} className="tf-header-2xl">
    {children}
  </div>
);
const ResponsesNotAvailable = ({ children }: PropsWithChildren) => (
  <Callout className="mt-8" center>
    {children}
  </Callout>
);

const SectionHeading = ({ children }: PropsWithChildren) => (
  <div className="mb-4">{children}</div>
);
const SectionHeadingTitle = ({ children }: PropsWithChildren) => (
  <div className="tf-header-lg-dark">{children}</div>
);
const SectionHeadingDescription = ({ children }: PropsWithChildren) => (
  <div className="tf-body-sm mt-1">{children}</div>
);

const SectionContainer = ({
  children,
  ...htmlProps
}: PropsWithChildren<Pick<HTMLAttributes<HTMLDivElement>, "aria-label">>) => (
  <div className="mt-16 first:mt-0" {...htmlProps}>
    {children}
  </div>
);
const SectionRegularQuestions = ({ children }: PropsWithChildren) => (
  <div className="flex flex-col gap-6">{children}</div>
);

AssessmentLayout.AssessmentTypeSection = AssessmentTypeSection;
AssessmentLayout.AssessmentTypeHeader = AssessmentTypeHeader;
AssessmentLayout.ResponsesNotAvailable = ResponsesNotAvailable;
AssessmentLayout.SectionHeading = SectionHeading;
AssessmentLayout.SectionHeadingTitle = SectionHeadingTitle;
AssessmentLayout.SectionHeadingDescription = SectionHeadingDescription;
AssessmentLayout.SectionContainer = SectionContainer;
AssessmentLayout.SectionRegularQuestions = SectionRegularQuestions;

export default AssessmentLayout;
